import { render, staticRenderFns } from "./pickingIndex.vue?vue&type=template&id=2d70a598&scoped=true&"
import script from "./pickingIndex.vue?vue&type=script&lang=js&"
export * from "./pickingIndex.vue?vue&type=script&lang=js&"
import style0 from "./pickingIndex.vue?vue&type=style&index=0&id=2d70a598&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70a598",
  null
  
)

export default component.exports